import { useState } from 'react';
import { Spinner } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';

const OfficeRenderer = ({ url, height = '80vh', width = '100%' }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const encodedUrl = encodeURIComponent(url);
    const viewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;

    if (!url) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height, width, color: '#6B7280', fontSize: '0.9rem' }}>
                No file URL provided.
            </div>
        );
    }

    return (
        <div style={{ position: 'relative', width, height, background: '#1E293B', borderRadius: 4, overflow: 'hidden' }}>
            {loading && !error && (
                <div style={{
                    position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', gap: 12, zIndex: 1,
                    background: '#1E293B',
                }}>
                    <Spinner style={{ color: '#A5B4FC', width: 36, height: 36 }} />
                    <span style={{ color: '#94A3B8', fontSize: '0.85rem' }}>Loading document preview…</span>
                </div>
            )}

            {error && (
                <div style={{
                    position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center', gap: 16, zIndex: 1,
                    background: '#1E293B',
                }}>
                    <div style={{
                        background: '#1E293B', border: '1px solid #334155', borderRadius: 12,
                        padding: '32px 40px', textAlign: 'center', maxWidth: 380,
                    }}>
                        <FeatherIcon icon="file-x" size={40} color="#64748B" style={{ marginBottom: 16 }} />
                        <div style={{ color: '#E2E8F0', fontWeight: 700, fontSize: '1rem', marginBottom: 8 }}>
                            Preview Unavailable
                        </div>
                        <div style={{ color: '#94A3B8', fontSize: '0.83rem', lineHeight: 1.6, marginBottom: 20 }}>
                            This document cannot be previewed inline. Please download it to view the full content.
                        </div>
                        <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            style={{
                                display: 'inline-flex', alignItems: 'center', gap: 8,
                                background: 'linear-gradient(135deg,#4F46E5,#6366F1)',
                                color: 'white', textDecoration: 'none', borderRadius: 8,
                                padding: '9px 20px', fontSize: '0.83rem', fontWeight: 700,
                                boxShadow: '0 2px 8px rgba(79,70,229,0.4)',
                            }}
                        >
                            <FeatherIcon icon="download" size={14} />
                            Download File
                        </a>
                    </div>
                </div>
            )}

            <iframe
                src={viewerUrl}
                title="Office document preview"
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ display: error ? 'none' : 'block', border: 'none' }}
                onLoad={() => setLoading(false)}
                onError={() => { setLoading(false); setError(true); }}
            />
        </div>
    );
};

export { OfficeRenderer };